import React from 'react';
import {
  ArrowDownOutlined,
  MinusOutlined,
  ArrowUpOutlined,
  FireOutlined,
} from '@ant-design/icons';

const priorityConfig = {
  low: { icon: <ArrowDownOutlined style={{ color: '#FBBF24' }} /> },
  medium: { icon: <MinusOutlined style={{ color: '#F59E0B' }} /> },
  high: { icon: <ArrowUpOutlined style={{ color: '#F97316' }} /> },
  highest: { icon: <FireOutlined style={{ color: '#DC2626' }} /> },
};

export default priorityConfig;
